import Vue from 'vue';
const resource = '/reports';

export default {
  getOrderPdf(idPublic) {
    return Vue.prototype.$axiosMainClient.get(`${resource}/orders/${idPublic}`);
  },
};
